import * as React from 'react'
import * as domain from '@packages/domain'
import { Row, Col, Button } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { identity, O, pipe } from '@packages/prelude'
import { react, Screen } from '../commons'
import { PostImage } from '../components/PostImage'

export interface BasePostProps {
  title: JSX.Element
  post: domain.Post.Type | domain.Event.Type | domain.Raffle.Type | domain.Podcast.Type
  image?: JSX.Element
}

const Container = styled(Row)`
  margin-bottom: 5rem;
  margin-top: 5rem;
  ${Screen.Desktop(css`
    border-left: 0.333333rem solid #bebebe;
  `)}
`

const PostContentWrapper = styled.div`
  position: relative;
  min-height: 100%;
  background-color: var(--light);
  padding: 2rem;
`
const PostLink = styled(Button)`
  position: absolute;
  right: 2rem;
  bottom: 0;
  transform: translateY(50%);
`

const PostTitle = styled.h2`
  text-transform: uppercase;
  ${Screen.smaller('sm')(css`
    font-size: 2rem;
  `)}
`

export const BasePost: React.VFC<React.PropsWithChildren<BasePostProps>> = ({ post, children, title, image }) => {
  return (
    <Container>
      <Col xs="auto" lg={{ offset: 1 }}>
        {pipe(title, O.fromNullable, O.foldMap(react.monoid)(identity))}
      </Col>
      <div className="w-100"></div>
      <Col sm={4} lg={{ offset: 1 }}>
        {pipe(
          image,
          O.fromNullable,
          O.fold(() => <PostImage {...post} />, identity)
        )}
      </Col>
      <Col sm={7} lg={6}>
        <PostContentWrapper>
          <PostTitle>{post.title}</PostTitle>
          {children}
          <PostLink size="lg" variant="primary" href={post.uri}>
            weiterlesen
            <i className="fa-solid fa-arrow-right-long ms-3"></i>
          </PostLink>
        </PostContentWrapper>
      </Col>
    </Container>
  )
}
